"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var loading_modal_1 = __importDefault(require("../../../components/loading_modal"));
var utils_1 = require("../../../utils");
var childOptions_1 = require("./childOptions");
var edit_child_fields_1 = __importDefault(require("./edit-child-fields"));
exports.default = (function (_a) {
    var _b, _c;
    var groupedSubscription = _a.groupedSubscription, openDrawer = _a.openDrawer, setOpenDrawer = _a.setOpenDrawer, bundleInfo = _a.bundleInfo, customerId = _a.customerId, bundleType = _a.bundleType;
    var shouldShowChildrenOptions = !(0, utils_1.isNonDiaperBundleType)(bundleType);
    var _d = __read((0, react_1.useState)(false), 2), isLoading = _d[0], setIsLoading = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isError = _e[0], setIsError = _e[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isLoading, error: isError }),
        react_1.default.createElement("a", { onClick: function () { return setOpenDrawer(openDrawer === 'edit_child' ? undefined : 'edit_child'); } },
            react_1.default.createElement("div", { className: 'account-subheader' },
                (bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.name) || "".concat(shouldShowChildrenOptions ? 'Add Child' : 'Add Name'),
                react_1.default.createElement("span", { className: "arrow ".concat(openDrawer === 'edit_child' ? 'up' : 'down') })),
            shouldShowChildrenOptions && (react_1.default.createElement("div", null,
                (bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.gender) && react_1.default.createElement("p", null,
                    "Gender: ", (_b = childOptions_1.genderOptions.find(function (g) { return g.value === bundleInfo.gender; })) === null || _b === void 0 ? void 0 :
                    _b.text),
                Number.isInteger(bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.birthMonth) && react_1.default.createElement("p", null,
                    "Birth Month: ", (_c = childOptions_1.birthMonths.find(function (bm) { return bm.value === (bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.birthMonth); })) === null || _c === void 0 ? void 0 :
                    _c.text),
                (bundleInfo === null || bundleInfo === void 0 ? void 0 : bundleInfo.birthYear) && react_1.default.createElement("p", null,
                    "Birth Year: ",
                    bundleInfo.birthYear)))),
        openDrawer === 'edit_child' ? (react_1.default.createElement(edit_child_fields_1.default, { setIsLoading: setIsLoading, setIsError: setIsError, groupedSubscription: groupedSubscription, bundleInfo: bundleInfo, bundleType: bundleType, customerId: customerId })) : (react_1.default.createElement(react_1.default.Fragment, null))));
});
